// Text content for all POI sections
// Edit this file to update the displayed text content

// Dimension measurements (in meters)
export const DIMENSION_MEASUREMENTS = {
  // Scene 2 - Black Arrow rocket stages
  FIRST_STAGE_HEIGHT: 6.9,
  FIRST_STAGE_DIAMETER: 2.00,
  SECOND_STAGE_HEIGHT: 2.9,
  SECOND_STAGE_DIAMETER: 1.37,
  THIRD_STAGE_HEIGHT: 1.22,
  THIRD_STAGE_DIAMETER: 0.76,
  PROSPERO_HEIGHT: 0.75,
  PROSPERO_DIAMETER: 0.51,
  
  // Total rocket measurements
  TOTAL_HEIGHT: 13.03,
  TOTAL_MASS: 18143 // kg
}

export const SCENE1_POI_CONTENT = {
  'POI_LP_Clamp': {
    title: 'PROPULSION/ENGINE',
    body: `The Black Arrow's choice of high-test peroxide (85% H₂O₂) and kerosene was a defining feature inherited from the Black Knight program. This combination offered a unique set of trade-offs and technical advantages over the more common LOX/Kerosene fuel.<div class="fuel-table-container"><div class="fuel-table"><div class="fuel-table-header">FUEL</div><div class="fuel-table-header fuel-table-header-merged">RP-1</div><div class="fuel-table-label">Oxidiser</div><div class="fuel-table-value">LOX</div><div class="fuel-table-value">HTP</div><div class="fuel-table-label">Specific Impulse</div><div class="fuel-table-value">↑ ~300-320 s</div><div class="fuel-table-value">↓ ~278 s</div><div class="fuel-table-label">Propellant Density</div><div class="fuel-table-value">↓1.14 kg/L</div><div class="fuel-table-value">↑1.4 kg/L</div><div class="fuel-table-label">Volumetric Impulse</div><div class="fuel-table-value">↓ Lower</div><div class="fuel-table-value">↑ Significantly Higher</div><div class="fuel-table-label">Storage</div><div class="fuel-table-value">Cryogenic</div><div class="fuel-table-value">Room Temperature</div></div></div><div class="fuel-advantages"><div class="fuel-advantages-title">Key Advantages of HTP/Kerosene:</div><div class="fuel-advantage-item"><span class="fuel-advantage-number">1. High Density:</span> HTP is significantly denser than LOX, and the engine required an oxidizer-to-fuel ratio of 8:1. This high propellant density results in a superior "volumetric impulse" (impulse per unit volume), allowing for smaller, more compact rocket stages. This in turn reduces the vehicle's overall mass and aerodynamic drag.</div><div class="fuel-advantage-item"><span class="fuel-advantage-number">2. Room-Temperature Propellant:</span> HTP is not cryogenic, eliminating the need for complex insulation and handling procedures associated with liquid oxygen.</div></div>`
  },
  'POI_LP_Fuel': {
    title: 'POTENTIAL REVIVAL',
    body: `<div class="revival-section"><p>The program's greatest success was also its last flight. The successful launch of the Prospero satellite occurred with the knowledge that the Black Arrow program had already been cancelled by the UK government. This outcome gives Britain a unique and bittersweet place in space history.</p><p>Britain is the only country to have developed a rocket of its own design, delivered a payload into orbit, and then abandon satellite launch capability.</p></div><ul class="revival-list"><li><span class="revival-list-title">A New Hope:</span> Fifty years after the cancellation of Black Arrow, there is a renewed prospect of orbital launch from British soil.</li><li><span class="revival-list-title">Skyrora XL:</span> This rocket is designed to carry up to 315 kg of small satellites into orbit, and will launch from the SaxaVord Spaceport in the Shetland Islands.</li><li><span class="revival-list-title">A European First:</span> If successful, this would mark a major milestone, as it would be the first time a European-built rocket has launched to orbit from a site in Europe.</li></ul><div class="revival-logos"><div class="revival-logo-item"><img src="/textures/logos/Skyrora.webp" alt="Skyrora" class="revival-logo-image" /><div class="revival-logo-text">Booth C10</div></div></div>`
  },
  'POI_LP_Shack': {
    title: 'LAUNCH HISTORY',
    body: `All Black Arrow rockets were manufactured in Britain and transported to the Woomera rocket range in Australia for launch.<div class="timeline">
  <div class="timeline-event">
    <div class="timeline-date">R0<br><span class="timeline-date-detail">June<br>1969</span><br><span class="timeline-status timeline-status-failure">Failure</span></div>
       <div class="timeline-line"></div>
       <div class="timeline-desc">A suborbital test with a boilerplate payload. The vehicle began oscillating out of control shortly after liftoff and was destroyed by range safety about a minute into the flight.</div>
  </div>
  <div class="timeline-event">
    <div class="timeline-date">R1<br><span class="timeline-date-detail">March<br>1970</span><br><span class="timeline-status timeline-status-success">Success</span></div>
       <div class="timeline-line"></div>
       <div class="timeline-desc">A successful suborbital test flight.</div>
  </div>
  <div class="timeline-event">
    <div class="timeline-date">R2<br><span class="timeline-date-detail">Sept<br>1970</span><br><span class="timeline-status timeline-status-failure">Failure</span></div>
       <div class="timeline-line"></div>
       <div class="timeline-desc">The first orbital attempt, carrying the Arbour satellite. A leak in the second stage oxidizer system caused the stage to shut down several seconds early. The payload failed to reach orbital velocity and re-entered the atmosphere before completing one orbit.</div>
  </div>
  <div class="timeline-event">
    <div class="timeline-date">R3<br><span class="timeline-date-detail">Oct<br>1971</span><br><span class="timeline-status timeline-status-success">Success</span></div>
       <div class="timeline-line"></div>
       <div class="timeline-desc">The vehicle successfully placed the Prospero satellite into orbit, where it remains to this day.</div>
  </div>
</div>`
  },
  'POI_LP_Origin': {
    title: 'BLACK ARROW',
    body: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est qui dolorem ipsum quia dolor sit amet.'
  }
}

export const SCENE2_POI_CONTENT = {
  'POI_BA_ST1': {
    title: 'FIRST STAGE',
    body: 'Built to metric specifications (2 meters wide, 6.9 meters long). It was powered by an eight-chamber version of the Gamma engine and burned for 127 seconds.'
  },
  'POI_BA_ST2': {
    title: 'SECOND STAGE',
    body: 'Built to imperial specifications (4 feet 6 inches wide). It used a two-chamber Gamma engine and burned for approximately two minutes.'
  },
  'POI_BA_ST3': {
    title: 'THIRD STAGE',
    body: 'A spin-stabilized solid rocket motor named Waxwing. It would spin up to three times per second before firing for 55 seconds to achieve final orbital injection.'
  },
  'POI_BA_PRO': {
    title: 'MISSION - FINDING PROSPERO',
    body: `Ralph Dinsley of Northern Space and Security confirmed that his organization has successfully located Prospero using open-source data. The satellite is in an elliptical orbit, ranging from approximately 520 km to 1300 km. A piece of the rocket body that launched it is in a similar orbit.<div class="timeline" style="margin-top: 32px;">
  <div class="timeline-event">
    <div class="timeline-date" style="width: 0; padding: 0;"></div>
       <div class="timeline-line" style="margin-left: 0;"></div>
       <div class="timeline-desc"><strong style="color: #ff4444;">Repatriation, Not Just Removal:</strong> The ultimate ambition extends beyond simple debris removal. The goal is to repatriate Prospero—to capture it and bring it back to Earth intact, where it could be displayed in a museum as an inspirational artifact.</div>
  </div>
  <div class="timeline-event">
    <div class="timeline-date" style="width: 0; padding: 0;"></div>
       <div class="timeline-line" style="margin-left: 0;"></div>
       <div class="timeline-desc"><strong style="color: #ff4444;">An Inclusive Mission:</strong> The project is designed to be highly inclusive, reaching beyond traditional aerospace engineering to involve space scientists, international law experts, historians, artists, and students from all levels (including the Air Cadets) to "ignite space in the UK."</div>
  </div>

</div>`
  }
}

// Scene 2 default view content (shown when not at a POI)
export const SCENE2_DEFAULT_CONTENT = {
  body: 'Authorised in 1964 and developed in parallel with the Europa project, the Black Arrow was a significantly smaller and less ambitious vehicle designed purely as a small satellite launcher.\n\nThe vehicle consisted of three stages with a notable mix of measurement systems, reflecting its design history and potential integration with European systems.'
}

// Default content for unknown POIs
export const DEFAULT_CONTENT = {
  title: 'INFORMATION',
  body: 'Lorem ipsum dolor sit amet.'
}

// Helper function to get content for a specific POI
export function getContentForPOI(poiName) {
  // Check Scene 1 POIs
  if (SCENE1_POI_CONTENT[poiName]) {
    return SCENE1_POI_CONTENT[poiName]
  }
  
  // Check Scene 2 POIs
  if (SCENE2_POI_CONTENT[poiName]) {
    return SCENE2_POI_CONTENT[poiName]
  }
  
  // Return default content if POI not found
  return DEFAULT_CONTENT
}
